import { render, staticRenderFns } from "./ProductContentDashboardSummary.vue?vue&type=template&id=7a9ff306&scoped=true&"
import script from "./ProductContentDashboardSummary.vue?vue&type=script&lang=js&"
export * from "./ProductContentDashboardSummary.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentDashboardSummary.vue?vue&type=style&index=0&id=7a9ff306&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9ff306",
  null
  
)

export default component.exports